export default "__VITE_ASSET__60fba864__"